/*
 * @Author: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-10 12:00:23
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-10-16 18:16:51
 * @FilePath: \fe-crm\src\store\modules\followRecords.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { publicService } from '@/api/';
import { defineStore } from 'pinia';
// import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
import i18n from '@/locales/index';
export const useFollowRecords = defineStore('getfollowRecords', {
  state: () => ({
    followRecordsList: [],
    isUpdate: false
  }),
  actions: {
    //获取动态记录列表
    getFollowRecords(params) {
      this.followRecordsList = [];
      this.isUpdate = params?.isUpdate || false;
      return new Promise((resolve, reject) => {
        publicService
          .getFollowList(params)
          .then((json) => {
            if (json.error) {
              Message.error(json.error?.msg || i18n.global.t('操作失败'));
            }
            this.followRecordsList = json.result;
            resolve(json);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || i18n.global.t('获取失败'));
            reject(err);
          });
      });
    },
    //添加动态记录
    addFollow(params, cb) {
      console.log('params::', params);
      return new Promise((resolve, reject) => {
        publicService
          .addFollow(params)
          .then((json) => {
            if (!json.error) {
              Message.success(i18n.global.t('操作成功'));
              if (params.isUpdate) {
                //true刷新动态记录列表
                this.getFollowRecords({ id: params.id, type: params.type, page: 1, pageSize: 100, isUpdate: true }); //刷新动态记录列表
              }
              cb && cb();
            } else {
              Message.error(json.error?.msg || i18n.global.t('操作失败'));
            }
            resolve(json);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || i18n.global.t('操作失败'));
            reject(err);
          });
      });
    },
    //编辑动态记录
    updateFollow(params, cb) {
      return new Promise((resolve, reject) => {
        publicService
          .updateFollow(params)
          .then((json) => {
            if (!json.error) {
              Message.success(i18n.global.t('操作成功'));
              if (params.isUpdate) {
                //true刷新动态记录列表
                this.getFollowRecords({ id: params.id, type: params.type, page: 1, pageSize: 100 }); //刷新动态记录列表
              }
              cb && cb();
            } else {
              Message.error(json.error?.msg || i18n.global.t('操作失败'));
            }
            resolve(json);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || i18n.global.t('操作失败'));
            reject(err);
          });
      });
    }
  }
});

export default useFollowRecords;
